import { apiFetch } from "./api";

let cachedUser = null;
let hasCachedUser = false;
let pendingRequest = null;
let cacheVersion = 0;

export async function getCurrentUser({ force = false } = {}) {
  if (!force && hasCachedUser) return cachedUser;
  if (!force && pendingRequest) return pendingRequest;

  const requestVersion = cacheVersion;
  const request = (async () => {
    const response = await apiFetch("/api/auth/me");
    if (!response.ok) {
      if (requestVersion === cacheVersion) {
        cachedUser = null;
        hasCachedUser = true;
      }
      return null;
    }

    const data = await response.json();
    const user = data?.authenticated ? data : null;
    if (requestVersion === cacheVersion) {
      cachedUser = user;
      hasCachedUser = true;
    }
    return user;
  })();
  pendingRequest = request;

  try {
    return await request;
  } finally {
    if (pendingRequest === request) pendingRequest = null;
  }
}

export function getCachedCurrentUser() {
  return hasCachedUser ? cachedUser : null;
}

export function clearCurrentUser() {
  cacheVersion += 1;
  cachedUser = null;
  hasCachedUser = false;
  pendingRequest = null;
}

export function updateCurrentUser(updates) {
  if (!hasCachedUser || !cachedUser) return;
  cachedUser = { ...cachedUser, ...updates };
}
